export default __webpack_public_path__ + "static/media/whatsapp.fb256dc4.png";